import { EndOfLifeItem } from '@/plugins/sensitive/models/endOfLife';

export const mapping = {
  EndOfLifeItem,
};
